export const UI_MODE_COOKIE = "FS_UI_MODE";
export const UI_MODE_LS_KEY = "FS_UI_MODE";
